/*
 * Copyright 2026 Sophos Limited. All rights reserved.
 *
 * 'Sophos' and 'Sophos Anti-Virus' are registered trademarks of Sophos Limited and Sophos Group. All other product
 * and company names mentioned are trademarks or registered trademarks of their respective owners.
 */
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { type ReactElement } from "react";
import { type CloudSourcesResult } from "../../services/dailyChecksApi";

type CloudSourcesTableProps = {
  /** Cloud Source integration health data */
  data: CloudSourcesResult;
};

/** Renders cloud source health — volume, error orgs and error percentage per source type */
export function CloudSourcesTable({ data }: CloudSourcesTableProps): ReactElement {
  return (
    <TableContainer>
      <Table size="small" aria-label="cloud-sources">
        <TableHead>
          <TableRow>
            <TableCell>Source</TableCell>
            <TableCell align="right">Total Orgs</TableCell>
            <TableCell align="right">Error Orgs</TableCell>
            <TableCell align="right">Error %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.sources.map((src, i) => (
            <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell>{src.name}</TableCell>
              <TableCell align="right">{src.totalOrgs.toLocaleString()}</TableCell>
              <TableCell align="right">{src.errorOrgs.toLocaleString()}</TableCell>
              <TableCell align="right">{src.errorPercentage.toFixed(1)}%</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
